import * as z from "zod";

import { format, setMinutes } from "date-fns";

function formatDate(date: Date) {
    return format(setMinutes(date, 0), "yyyy-MM-dd'T'HH:mm");
}

const requiredError = {
    message: "validated-question-create.date.errors.required",
};

export const issueAtSchema = z
    .number(requiredError)
    .or(z.string(requiredError))
    .transform((val) => {
        if (typeof val === "string") {
            // Check if the string is a valid number and if so, convert it to a number
            if (!isNaN(Number(val))) {
                return Number(val);
            }
        }
        return val;
    })
    .transform((s) => {
        const date = s ? new Date(s) : new Date();
        return formatDate(date);
    });
